var map = {
	"./bg-BG.json": 2562,
	"./ca-ES.json": 2563,
	"./cs-CZ.json": 2564,
	"./de-DE.json": 2565,
	"./el-GR.json": 2566,
	"./en-US.json": 1386,
	"./es-ES.json": 2567,
	"./et-EE.json": 2568,
	"./fi-FI.json": 2569,
	"./fr-FR.json": 2570,
	"./he-IL.json": 2571,
	"./it-IT.json": 2572,
	"./ja-JP.json": 2573,
	"./ko-KR.json": 2574,
	"./nb-NO.json": 2575,
	"./nl-NL.json": 2576,
	"./nn-NO.json": 2577,
	"./pl-PL.json": 2578,
	"./pt-BR.json": 2579,
	"./ro-RO.json": 2580,
	"./ru-RU.json": 2581,
	"./sk-SK.json": 2582,
	"./sv-SE.json": 2583,
	"./tr-TR.json": 2584,
	"./zh-CN.json": 2585
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2561;